<template>
  <div id="Subscriptions" v-if='user'>
    <v-layout row v-if="error">
      <v-flex xs12>
        <Alert @dismissed="onDismissed" :text="error.message" ></Alert>
      </v-flex>
    </v-layout>
    <div >

      <v-card flat class="mt-3 " style="borderRadius:5px" >

        <v-card-text class="px-2">

          <!-- SUBSCRIPTION AMOUNT && PROMO CODE SECTION -->
          <v-layout v-if="(activeSubscriptions === null || activeSubscriptions === undefined) && !creatingSubscription" column align-center justify-center>
            <v-layout v-if="subscriptionPreview" row align-center justify-center>
              <span class="display-1 font-weight-regular">${{chargeAmount}} <span class="caption grey--text font-weight-bold"> </span> </span>
            </v-layout>

           <v-layout column mt-1 align-center justify-center>
              <span v-if="subscriptionPreview"><small>Yearly Subscription: ${{ formatPrice(subscriptionPreview.plan.amount, 0) }}</small></span>
              <span v-if="subscriptionPreview"><small>Includes Tax: {{ subscriptionPreview.tax_rate.percentage }}%</small></span>
           </v-layout>

            <!-- PROMO CODE INPUT -->
             <v-layout style="width:95%" class="coupon-box">
              <input v-model="promoCode" class="promoCodeInput"  placeholder="Promo Code" type="text">
              <v-btn :loading="promoLoading" @click="fetchCouponCode" :disabled="!promoCode || promoData" color="primary" :depressed="!promoCode" small class="coupon-box__button">Apply</v-btn>
            </v-layout>
            <p class="green--text mb-1 mt-1" v-if="promoData">You have received a discount of <span v-if="promoData.amount_off">{{parseFloat(promoData.amount_off/100).toFixed(2)}}</span> <span v-else>{{promoData.percent_off}}%</span></p>
            <p class="red--text mt-1 mb-1" v-if="promoError">Invalid Coupon Code</p>

          </v-layout>

          <!-- ACTIVE SUBSCRIPTION CARD -->
          <v-card v-for="(value, key) in activeSubscriptions" :key="key" v-if="activeSubscriptions" style="borderRadius:5px" outlined>
            <v-layout v-if='value.subscription.id' justify-center  class=" green pb-2  ">
                <span class=" subtitle-2 white--text text-center mt-2"> Yearly Subscription Active</span>
              </v-layout>

            <v-card-text>
              <span class="black--text" >From: </span>{{ value.subscription.current_period_start | moment(" MM/DD/YYYY") }} <br>
              <span class="black--text" >Expires: </span>{{ value.subscription.current_period_end | moment(" MM/DD/YYYY") }} <br>
             <v-layout justify-center align-center>
                <v-btn color="red " v-if="!value.subscription.cancel_at_period_end"   small dark class='pay-with-stripe md-position-custom mt-3 elevation-0 ' @click='handleCancelSubscription(key)'>Cancel</v-btn>
                <v-btn color="red white--text" v-if="value.subscription.cancel_at_period_end" block small  class='pay-with-stripe mt-3 md-position-custom' disabled>Cancels on Expiry</v-btn>
             </v-layout>
            </v-card-text>
            <v-card-title v-if='value.creating' class="subheading grey lighten-3 ">Creating Subscription...</v-card-title>
          </v-card>

          <v-layout align-center justify-center>
            <v-btn
              v-if="activeSubscriptions == null && stripeSources !== null && !stripeSources.length && !creatingSubscription"
              id="submitButton"
              color=" green white--text"
              class="mt-3 "
              large
              style="width: 95%"
              @click='handleSubscribeNow'
            >
              <span>Subscribe Now</span>
            </v-btn>
          </v-layout>



              <!-- CREATING SUBSCRIPTION LOADER -->
              <v-card flat v-if='creatingSubscription'>
                <v-layout column align-center justify-center>

                    <v-progress-circular
                      :size="100"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                    <span class="mt-3 subheading font-weight-regular">Creating Subscription</span>
                </v-layout>

              </v-card>




          <v-layout column justify-center align-center mt-3>
            <v-btn v-if="stripeSources === null || stripeSources === undefined" id="submitButton " color=" blue white--text" style="width: 95%"  large  class='pay-with-stripe mt-2' @click='handleAddNewCard(null)' :disabled='addNewCardModal'>Add Credit Card </v-btn>
          </v-layout>






        </v-card-text>
      </v-card>
      <!-- LISt USERS PAYMENTS -->
      <!-- LISt USERS SUBSCRIPTIONS -->

      <v-card v-if="stripeSources"  class=" mt-4 mx-2 elevation-0" style="borderRadius:5px" outlined >
         <v-layout  justify-center  class=" grey lighten-3 pb-2  ">
                <span class="  black--text text-center mt-2">My Card</span>
              </v-layout>
        <v-card-title class="subheading pb-1 px-0 pt-0">

        </v-card-title>
        <v-card-text class="px-5 mt-2 pb-1">

            <v-layout v-for="(value, key) in stripeSources" :key="key" row align-center px-1>


                <v-layout v-if='!value.error && value.last4 === undefined' column align-center justify-center>

                    <v-progress-circular
                      :size="100"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                    <span class="mt-3 subheading font-weight-regular">Adding Your Card</span>
                </v-layout>



              <v-layout v-else-if="!value.error" align-center justify-space-between>
                <span class="subtitle-1 ml-4">
                  <v-layout row align-center>
                    <svg v-if="value.brand === 'Visa' " width="35px" height="25px" viewBox="0 0 35 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="CREDIT-CARDS" transform="translate(-28.000000, -62.000000)">
                                <g id="35x25" transform="translate(28.000000, 62.000000)">
                                    <g id="visa">
                                        <rect id="visa-bg" fill="#224DBA" x="0" y="0" width="35" height="25" rx="3.31578947"></rect>
                                        <path d="M11.925,16.674 L9.874,16.674 L8.336,10.674 C8.263,10.398 8.108,10.154 7.88,10.039 C7.311,9.75 6.684,9.52 6,9.404 L6,9.173 L9.304,9.173 C9.76,9.173 10.102,9.52 10.159,9.923 L10.957,14.251 L13.007,9.173 L15.001,9.173 L11.925,16.674 Z M16.141,16.674 L14.204,16.674 L15.799,9.173 L17.736,9.173 L16.141,16.674 Z M20.242,11.251 C20.299,10.847 20.641,10.616 21.04,10.616 C21.667,10.558 22.35,10.674 22.92,10.962 L23.262,9.347 C22.692,9.116 22.065,9 21.496,9 C19.616,9 18.248,10.039 18.248,11.481 C18.248,12.578 19.217,13.154 19.901,13.501 C20.641,13.847 20.926,14.078 20.869,14.424 C20.869,14.943 20.299,15.174 19.73,15.174 C19.046,15.174 18.362,15.001 17.736,14.712 L17.394,16.328 C18.078,16.616 18.818,16.732 19.502,16.732 C21.61,16.789 22.92,15.751 22.92,14.193 C22.92,12.231 20.242,12.116 20.242,11.251 L20.242,11.251 Z M29.699,16.674 L28.161,9.173 L26.509,9.173 C26.167,9.173 25.825,9.404 25.711,9.75 L22.863,16.674 L24.857,16.674 L25.255,15.578 L27.705,15.578 L27.933,16.674 L29.699,16.674 Z M26.794,11.193 L27.363,14.02 L25.768,14.02 L26.794,11.193 Z" id="visa-logo" fill="#FFFFFF"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <svg v-if="value.brand === 'MasterCard'" width="35px" height="25px" viewBox="0 0 35 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="CREDIT-CARDS" transform="translate(-196.000000, -62.000000)">
                                <g id="35x25" transform="translate(28.000000, 62.000000)">
                                    <g id="mastercard" transform="translate(168.000000, 0.000000)">
                                        <rect id="mastercard-bg" fill="#353A48" x="0" y="0" width="35" height="25" rx="3.31578947"></rect>
                                        <g id="mastercard-logo" transform="translate(6.263158, 5.597015)">
                                            <path d="M15.8421053,0.126959854 C19.6063618,0.126959854 22.6578947,3.21753154 22.6578947,7.02994493 C22.6578947,10.8423583 19.6063618,13.93293 15.8421053,13.93293 C14.1550872,13.93293 12.6112226,13.3121755 11.4210429,12.283891 C10.2317473,13.3118278 8.68749053,13.93293 7,13.93293 C3.23574342,13.93293 0.184210526,10.8423583 0.184210526,7.02994493 C0.184210526,3.21753154 3.23574342,0.126959854 7,0.126959854 C8.68749053,0.126959854 10.2317473,0.74806206 11.4220622,1.77686278 C12.6112226,0.747714347 14.1550872,0.126959854 15.8421053,0.126959854 Z" id="Combined-Shape" fill="#FF5E00"></path>
                                            <path d="M7,0.126959854 C8.68749053,0.126959854 10.2317473,0.74806206 11.4220622,1.77686278 C9.95556529,3.04213347 9.02631579,4.92613197 9.02631579,7.02994493 C9.02631579,9.13375789 9.95556529,11.0177564 11.4210429,12.283891 C10.2317473,13.3118278 8.68749053,13.93293 7,13.93293 C3.23574342,13.93293 0.184210526,10.8423583 0.184210526,7.02994493 C0.184210526,3.21753154 3.23574342,0.126959854 7,0.126959854 Z" id="Combined-Shape" fill="#ED0006"></path>
                                            <path d="M15.8421053,0.126959854 C19.6063618,0.126959854 22.6578947,3.21753154 22.6578947,7.02994493 C22.6578947,10.8423583 19.6063618,13.93293 15.8421053,13.93293 C14.1548438,13.93293 12.6107772,13.3119964 11.4205278,12.283446 C12.8867577,11.0173149 13.8157895,9.13351141 13.8157895,7.02994493 C13.8157895,4.92637845 12.8867577,3.04257493 11.4215775,1.77644386 C12.6107772,0.74789346 14.1548438,0.126959854 15.8421053,0.126959854 Z" id="Combined-Shape" fill="#F9A000"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <svg v-if="value.brand === 'Discover'" width="35px" height="25px" viewBox="0 0 35 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="CREDIT-CARDS" transform="translate(-154.000000, -62.000000)">
                                <g id="35x25" transform="translate(28.000000, 62.000000)">
                                    <g id="discover" transform="translate(126.000000, 0.000000)">
                                        <rect id="discover-bg" fill="#FFA200" x="0" y="0" width="35" height="25" rx="3.35820896"></rect>
                                        <path d="M29.8828148,12.3192152 L29.618203,12.3192152 L29.618203,10.9118899 L29.8828148,10.9118899 C30.4649607,10.9118899 30.7295726,11.1725057 30.7295726,11.5894909 C30.7295726,12.0585994 30.4649607,12.3192152 29.8828148,12.3192152 L29.8828148,12.3192152 Z M31.6821751,11.5373678 C31.6821751,10.6512741 31.1000291,10.1821656 30.0415819,10.1821656 L28.7185228,10.1821656 L28.7185228,14.8211268 L29.618203,14.8211268 L29.618203,12.9446931 L29.7240477,12.9446931 L30.941262,14.8211268 L32.0526316,14.8211268 L30.6237278,12.8925699 C31.2587962,12.7883236 31.7350974,12.2149689 31.6821751,11.5373678 L31.6821751,11.5373678 Z M25.5961035,14.8211268 L28.1363769,14.8211268 L28.1363769,14.0392794 L26.4957837,14.0392794 L26.4957837,12.7883236 L28.0834545,12.7883236 L28.0834545,12.0064762 L26.4957837,12.0064762 L26.4957837,10.964013 L28.1363769,10.964013 L28.1363769,10.1821656 L25.5961035,10.1821656 L25.5961035,14.8211268 L25.5961035,14.8211268 Z M22.9499855,13.3095552 L21.7327712,10.1821656 L20.7801687,10.1821656 L22.738296,14.9253731 L23.2145973,14.9253731 L25.1727246,10.1821656 L24.2201221,10.1821656 L22.9499855,13.3095552 L22.9499855,13.3095552 Z M12.2067461,12.5277078 C12.2067461,13.8307868 13.2651934,14.9253731 14.5882524,14.9253731 C15.0116313,14.9253731 15.3820878,14.8211268 15.7525443,14.6647573 L15.7525443,13.6222942 C15.4879325,13.9350331 15.117476,14.1435257 14.6940971,14.1435257 C13.8473393,14.1435257 13.1593486,13.5180478 13.1593486,12.6840773 L13.1593486,12.579831 C13.1064263,11.7458604 13.794417,11.0161362 14.6411748,10.964013 C15.0645536,10.964013 15.4879325,11.1725057 15.7525443,11.4852446 L15.7525443,10.4427814 C15.4350102,10.2342888 15.0116313,10.1821656 14.6411748,10.1821656 C13.2651934,10.0779193 12.2067461,11.1725057 12.2067461,12.5277078 L12.2067461,12.5277078 Z M10.566153,11.9543531 C10.0369293,11.7458604 9.87816226,11.6416141 9.87816226,11.3809983 C9.93108462,11.0682593 10.1956964,10.8076435 10.5132306,10.8597667 C10.7778424,10.8597667 11.0424542,11.0161362 11.2541436,11.2246288 L11.7304449,10.5991509 C11.3599884,10.286412 10.8836871,10.0779193 10.4073859,10.0779193 C9.66647281,10.0257962 9.03140448,10.5991509 8.97848212,11.3288751 L8.97848212,11.3809983 C8.97848212,12.0064762 9.24309392,12.3713383 10.0898517,12.6319541 C10.3015411,12.6840773 10.5132306,12.7883236 10.72492,12.8925699 C10.8836871,12.9968162 10.9895318,13.1531857 10.9895318,13.3616784 C10.9895318,13.7265405 10.6719977,14.0392794 10.3544635,14.0392794 L10.3015411,14.0392794 C9.87816226,14.0392794 9.50770573,13.7786636 9.34893864,13.4138015 L8.76679267,13.9871563 C9.08432684,14.560511 9.71939517,14.87325 10.3544635,14.87325 C11.2012213,14.9253731 11.889212,14.2998952 11.9421343,13.4659247 L11.9421343,13.3095552 C11.889212,12.6840773 11.6246002,12.3713383 10.566153,11.9543531 L10.566153,11.9543531 Z M7.496656,14.8211268 L8.39633614,14.8211268 L8.39633614,10.1821656 L7.496656,10.1821656 L7.496656,14.8211268 L7.496656,14.8211268 Z M5.69729573,13.6744173 C5.37976156,13.9350331 4.90346031,14.0914026 4.48008142,14.0392794 L4.21546961,14.0392794 L4.21546961,10.964013 L4.48008142,10.964013 C4.90346031,10.9118899 5.37976156,11.0682593 5.69729573,11.3288751 C6.01482989,11.6416141 6.17359698,12.0585994 6.17359698,12.4755846 C6.17359698,12.9446931 6.01482989,13.3616784 5.69729573,13.6744173 L5.69729573,13.6744173 Z M4.6388485,10.1821656 L3.31578947,10.1821656 L3.31578947,14.8211268 L4.6388485,14.8211268 C5.22099448,14.87325 5.80314045,14.6647573 6.2794417,14.2998952 C6.80866531,13.8307868 7.12619948,13.2053089 7.12619948,12.5277078 C7.17912184,11.276752 6.17359698,10.2342888 4.90346031,10.1821656 L4.6388485,10.1821656 L4.6388485,10.1821656 Z M18.4515848,10.0746269 C17.1285257,10.0746269 16.0171562,11.1170901 16.0171562,12.4722922 C16.0171562,13.7753712 17.0756034,14.8699575 18.4515848,14.9220807 C19.8275662,14.9742038 20.8860134,13.8796175 20.9389357,12.5244154 C20.8860134,11.1692132 19.8275662,10.0746269 18.4515848,10.0746269 L18.4515848,10.0746269 Z" id="discover-logo" fill="#FFFFFF"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <svg v-if="value.brand === 'American Express'" width="35px" height="25px" viewBox="0 0 35 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="CREDIT-CARDS" transform="translate(-112.000000, -62.000000)">
                                <g id="35x25" transform="translate(28.000000, 62.000000)">
                                    <g id="amex" transform="translate(84.000000, 0.000000)">
                                        <rect id="amex-bg" fill="#007ECD" x="0" y="0" width="35" height="25" rx="3.31578947"></rect>
                                        <path d="M30.7453138,16.988775 L29.2087961,16.988775 L29.2087961,16.2149763 L30.5498044,16.2149763 C30.5498044,16.2149763 31.0387641,16.2718253 31.0387641,15.9488359 C31.0387641,15.6461238 30.3077451,15.66966 30.3077451,15.66966 C30.3077451,15.66966 29.1164411,15.7721331 29.1164411,14.6688272 C29.1164411,13.5713148 30.1926739,13.6339573 30.1926739,13.6339573 L31.84538,13.6339573 L31.84538,14.418619 L30.5151713,14.418619 C30.5151713,14.418619 30.0545139,14.3270087 30.0545139,14.6579643 C30.0545139,14.9353297 30.682006,14.8958612 30.682006,14.8958612 C30.682006,14.8958612 31.9999255,14.7995438 31.9999255,15.8116015 C31.9999255,16.8964406 31.1508561,16.9931202 30.8495854,16.9931202 C30.784788,16.9931202 30.7453138,16.988775 30.7453138,16.988775 L30.7453138,16.988775 Z M23.0794832,16.9942065 L23.0794832,13.6397509 L25.7722994,13.6397509 L25.7722994,14.418619 L23.9479174,14.418619 L23.9479174,14.9353297 L25.7268667,14.9353297 L25.7268667,15.6979035 L23.9479174,15.6979035 L23.9479174,16.2671181 L25.7722994,16.2671181 L25.7722994,16.9942065 L23.0794832,16.9942065 Z M27.7009531,16.988775 L26.164063,16.988775 L26.164063,16.2149763 L27.5110297,16.2149763 C27.5110297,16.2149763 27.9944034,16.2718253 27.9944034,15.9488359 C27.9944034,15.6461238 27.2633844,15.66966 27.2633844,15.66966 C27.2633844,15.66966 26.0720805,15.7721331 26.0720805,14.6688272 C26.0720805,13.5713148 27.1483132,13.6339573 27.1483132,13.6339573 L28.8066053,13.6339573 L28.8066053,14.418619 L27.471183,14.418619 C27.471183,14.418619 27.0101532,14.3270087 27.0101532,14.6579643 C27.0101532,14.9353297 27.6369005,14.8958612 27.6369005,14.8958612 C27.6369005,14.8958612 28.9555648,14.7995438 28.9555648,15.8116015 C28.9555648,16.8964406 28.1064954,16.9931202 27.8052248,16.9931202 C27.740055,16.9931202 27.7009531,16.988775 27.7009531,16.988775 L27.7009531,16.988775 Z M16.0575303,16.9945686 L15.303795,16.9945686 L14.3884386,15.9988051 L13.4678686,16.9945686 L12.9439034,16.9945686 L10.2563009,16.9945686 L10.2563009,13.6285259 L12.9439034,13.6285259 L13.3986024,13.6285259 L14.3884386,14.6974327 L15.3842332,13.6343194 L16.0463583,13.6343194 L16.0463583,13.6285259 L18.1411019,13.6285259 C18.1411019,13.6285259 19.2348374,13.5090343 19.2348374,14.6170475 C19.2348374,15.6066553 18.8713761,15.9140747 17.7556691,15.9140747 L16.9095789,15.9140747 L16.9095789,16.9945686 L16.0575303,16.9945686 L16.0575303,16.9945686 Z M14.9757116,15.3405149 L16.0463583,16.5111707 L16.0463583,14.1742043 L14.9757116,15.3405149 L14.9757116,15.3405149 Z M11.1254798,16.266756 L12.9439034,16.266756 L13.795952,15.3405149 L12.9439034,14.4189811 L11.1254798,14.4189811 L11.1254798,14.9356918 L12.8980984,14.9356918 L12.8980984,15.6982656 L11.1254798,15.6982656 L11.1254798,16.266756 L11.1254798,16.266756 Z M16.9095789,15.0378028 L17.8014742,15.0378028 C18.0606638,15.0378028 18.2736759,14.8958612 18.2736759,14.7195206 C18.2736759,14.5439041 18.0606638,14.4012384 17.8014742,14.4012384 L16.9095789,14.4012384 L16.9095789,15.0378028 L16.9095789,15.0378028 Z M21.8133271,17 L21.8133271,16.346055 C21.8133271,16.346055 21.7779492,15.8344136 21.2368537,15.8344136 L20.3974666,15.8344136 L20.3974666,17 L19.5335013,17 L19.5335013,13.6397509 L21.6289897,13.6397509 C21.6289897,13.6397509 22.7223527,13.5090343 22.7223527,14.6232031 C22.7223527,15.2032806 22.238979,15.4078647 22.238979,15.4078647 C22.238979,15.4078647 22.6534589,15.6012239 22.6534589,16.1693522 L22.6534589,17 L21.8133271,17 L21.8133271,17 Z M20.3974666,15.0439584 L21.2893619,15.0439584 C21.5485515,15.0439584 21.7611913,14.9020169 21.7611913,14.7256762 C21.7611913,14.5493356 21.5485515,14.407394 21.2893619,14.407394 L20.3974666,14.407394 L20.3974666,15.0439584 L20.3974666,15.0439584 Z M19.7468858,12.4002969 L20.61532,12.4002969 L20.61532,9.02918492 L19.7468858,9.02918492 L19.7468858,12.4002969 Z M13.0589747,12.3887099 L13.0589747,9.02882283 L15.7525356,9.02882283 L15.7525356,9.81312235 L13.9281536,9.81312235 L13.9281536,10.3305573 L15.7067306,10.3305573 L15.7067306,11.0924069 L13.9281536,11.0924069 L13.9281536,11.6616215 L15.7525356,11.6616215 L15.7525356,12.3887099 L13.0589747,12.3887099 Z M11.706422,12.3890719 L11.706422,10.0691241 L10.6246033,12.3890719 L9.91667309,12.3890719 L8.82889602,10.0803491 L8.82889602,12.3890719 L8.07478833,12.3890719 L7.95971708,12.3890719 L7.12517124,12.3890719 L6.82576255,11.6840714 L5.24902578,11.6840714 L4.94403111,12.3890719 L4,12.3890719 L5.43299082,9.02846073 L6.6473835,9.02846073 L7.95971708,12.1160517 L7.95971708,9.02846073 L9.32381411,9.02846073 L10.2734312,11.1152189 L11.2170899,9.02846073 L12.5811869,9.02846073 L12.5811869,12.3890719 L11.706422,12.3890719 Z M5.61732825,10.8251801 L6.45746008,10.8251801 L6.03739417,9.82470942 L5.61732825,10.8251801 Z M28.6673281,12.3890719 L27.2983899,10.1429916 L27.2983899,12.3890719 L26.5558266,12.3890719 L26.4169218,12.3890719 L25.6062095,12.3890719 L25.3012148,11.6840714 L23.7241056,11.6840714 L23.4243246,12.3890719 L22.6299978,12.3890719 L22.4862518,12.3890719 L22.0717719,12.3890719 C22.0717719,12.3890719 20.9098875,12.2239563 20.9098875,10.8027302 C20.9098875,8.93757468 22.227807,9.01144223 22.2732397,9.00021726 L23.337928,9.02846073 L23.337928,9.78487888 L22.4639079,9.79610385 C22.4639079,9.79610385 21.8937652,9.79610385 21.8241267,10.52971 C21.8166787,10.6144404 21.8125823,10.6912047 21.8133271,10.7632618 C21.8166787,11.8991563 22.8109836,11.5468371 22.8437547,11.5359742 L23.9140291,9.02846073 L25.122091,9.02846073 L26.4169218,12.0762212 L26.4169218,9.02846073 L27.6372729,9.02846073 L28.9898255,11.240504 L28.9898255,9.02846073 L29.8593769,9.02846073 L29.8593769,12.3890719 L28.6673281,12.3890719 L28.6673281,12.3890719 Z M24.0924081,10.8251801 L24.9329123,10.8251801 L24.5184324,9.82470942 L24.0924081,10.8251801 L24.0924081,10.8251801 Z M18.4803573,12.3890719 L18.4803573,11.7351269 C18.4803573,11.7351269 18.4460966,11.2234855 17.9050011,11.2234855 L17.0648692,11.2234855 L17.0648692,12.3890719 L16.2012763,12.3890719 L16.2012763,9.02846073 L18.2963923,9.02846073 C18.2963923,9.02846073 19.3897553,8.89774414 19.3897553,10.012275 C19.3897553,10.5923525 18.9063816,10.7969367 18.9063816,10.7969367 C18.9063816,10.7969367 19.3264475,10.9902958 19.3264475,11.5587863 L19.3264475,12.3890719 L18.4803573,12.3890719 Z M17.0648692,10.4330304 L17.9567645,10.4330304 C18.2159541,10.4330304 18.4285938,10.2907267 18.4285938,10.1143861 C18.4285938,9.9384075 18.2159541,9.79610385 17.9567645,9.79610385 L17.0648692,9.79610385 L17.0648692,10.4330304 Z" id="amex-logo" fill="#FFFFFF"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <svg v-if="value.brand === 'Diners Club'" width="35px" height="25px" viewBox="0 0 35 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="CREDIT-CARDS" transform="translate(-70.000000, -62.000000)">
                                <g id="35x25" transform="translate(28.000000, 62.000000)">
                                    <g id="diners-club" transform="translate(42.000000, 0.000000)">
                                        <rect id="dc-bg" fill="#2183CB" x="0" y="0" width="35" height="25" rx="3.31578947"></rect>
                                        <path d="M18.7721749,5.2247781 C22.7702431,5.1615091 26.0186735,8.45149724 26.0811433,12.5007134 L26.0811433,12.5639824 C25.9562037,16.5499296 22.7702431,19.7766487 18.7721749,19.7766487 L16.2109125,19.7766487 C12.337784,19.7133797 9.2142932,16.4866606 9.2142932,12.5639824 C9.08935357,8.64130425 12.0879047,5.35131611 15.8985634,5.2247781 L18.7721749,5.2247781 Z M16.398322,6.49015816 C13.1498916,6.49015816 10.4636895,9.21072527 10.4636895,12.5007134 C10.4636895,15.7907015 13.1498916,18.5112687 16.398322,18.5112687 C19.6467524,18.5112687 22.3329544,15.7907015 22.3329544,12.5007134 C22.3329544,9.21072527 19.6467524,6.49015816 16.398322,6.49015816 Z M17.3353692,8.51476624 C19.5218127,9.08418727 20.8961487,11.2986024 20.3339203,13.5130175 C19.9591014,15.0314735 18.8346448,16.1703156 17.3353692,16.5499296 L17.3353692,8.51476624 Z M15.4612747,8.51476624 L15.4612747,16.5499296 C13.2748312,15.9805086 11.9629651,13.7028245 12.5251934,11.4884094 C12.9000123,10.0332223 14.024469,8.89438026 15.4612747,8.51476624 Z" id="dc-logo" fill="#FFFFFF"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>

                    <v-layout class="ml-2"><span class="black--text">{{value.last4}} - {{value.exp_month}}/{{value.exp_year}}</span></v-layout>
                  </v-layout>
                </span>
                <v-btn icon small class='pay-with-stripe' @click='handleRemovePaymentSource(key)'><v-icon color="red" >mdi-delete</v-icon></v-btn>
              </v-layout>

             <v-layout column align-center justify-center pb-3  v-if="value.error">
                <span v-if="value.error" class="red--text">
                  {{ value.error }}
                  <v-btn  color=" blue white--text"  block large   class='pay-with-stripe elevation-6 mt-3' @click='handleAddNewCard(key)' :disabled='addNewCardModal'>Try Again</v-btn>
                </span>
             </v-layout>

            </v-layout>

        </v-card-text>

          <v-layout  align-center justify-center>

        </v-layout>

      </v-card>





      </div>



         <v-dialog
            v-model="addNewCardModal"
            scrollable
            max-width="400"
          >
            <v-card class="pb-2" style="borderRadius: 5px">
              <span class="title grey lighten-4 text-center font-weight-regular pa-3 ">Add Credit Card</span>
              <v-card-text>
              <v-layout column justify-center align-center>
                <input required class="promoInput " placeholder="Cardholder Name" v-model="cardHolderName" type="text">
                <input required class="promoInput " placeholder="Address line 1" v-model="addressLine1" type="text">
                <input class="promoInput " placeholder="Address line 2" v-model="addressLine2" type="text">
                <input required class="promoInput " placeholder="City" v-model="addressCity" type="text">
                <input required class="promoInput " placeholder="State" v-model="addressState" type="text">
                <!-- <input required class="promoInput " placeholder="Country Code" v-model="addressCountry" type="text"> -->
                <select v-model="addressCountry" class="promoInput">
                  <option disabled selected value="">Country Code</option>
                  <option :value="getCode(countryOption)" v-for="countryOption in countryOptions" :key="countryOption">{{countryOption}}</option>
                </select>



                <card class='stripe-card'
                  ref="card"
                  :class='{ stripePaymentFormComplete } '
                  :stripe='stripeKey'
                  @change='handlePaymentFormChange'
                  style="marginTop:20px"
                />
                <span class=' red--text' v-if="stripePaymentFormErrors">{{stripePaymentFormErrors.message}}</span>
                <v-btn  color=" green white--text"   style="width: 100%" large class='pay-with-stripe mt-4' @click='createPaymentSource' :disabled='!stripePaymentFormComplete || stripePaymentFormBusy'>Submit Card</v-btn>
                <v-btn @click="handleCancelAddNewCard" :disabled="stripePaymentFormBusy" color="red" dark block class="mt-3 elevation-0">
                  Cancel
                </v-btn>
              </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>
      </div>




</template>

<script>

import { Card, createToken } from 'vue-stripe-elements-plus'
import * as firebase from 'firebase'
import axios from 'axios'
import { formatPrice } from '@/lib/utils'
import { getCode, getNames } from 'country-list'

export default {
  components: { Card },
  mounted() {
    if (this.user) this.setSubscriptionsWatcher()
    if (!this.subscriptionPreview) this.fetchSubscriptionPreview()
  },
  beforeDestroy () {
    if (this.subscriptionsWatcher) this.subscriptionsWatcher()
    if (this.sourcesWatcher) this.sourcesWatcher()
  },
  data () {
    return {
      amount: 60,
      promoCode: null,
      addNewCardModal: false,
      stripePaymentFormComplete: false,
      stripePaymentFormErrors: null,
      stripePaymentFormBusy: false,
      subscriptionsWatcher: null,
      sourcesWatcher: null,
      activeSubscriptions: null,
      stripeSources: null,
      creatingSubscription: false,
      promoData: null,
      promoError: false,
      addressLine1: null,
      addressLine2: null,
      addressCity: null,
      addressState: null,
      addressCountry: "",
      cardHolderName: null,
      subscriptionPreview: null,
      promoLoading: false
    }
  },
  computed: {
    stripeKey () {
      return process.env.STRIPE_KEY
    },
    comparePasswords () {
      return this.password !== this.confirmPassword ? 'Passwords do not match' : true
    },
    user() {
      return this.$store.getters.user
    },
    error() {
      return this.$store.getters.error
    },
    creatingCard () {
      if (this.stripeSources) {
        return !!Object.values(this.stripeSources).filter((card) => !card.id).length
      }
      return false
    },
    chargeAmount () {
      if (!this.subscriptionPreview) return 'Loading...'
      const { plan, tax_rate = null, coupon = null } = this.subscriptionPreview
      let total = plan.amount
      if (tax_rate) {
        total += total * (tax_rate.percentage/100)
      }
      if(this.promoData) {
        if(this.promoData.amount_off) {
          return formatPrice((total - (this.promoData.amount_off)))
        } else {
          return formatPrice(total- (total * this.promoData.percent_off/100))
        }
      } else {
         return formatPrice(total)
      }
    },
    countryOptions () {
      return getNames()
    }
  },
  watch: {
    user (newVal, oldVal) {

      if (newVal !== oldVal && newVal) {
        this.setSubscriptionsWatcher()
      }

    },
    //  addressCountry () {
    //     console.log(this.countryList)
    //   },
    activeSubscriptions (newVal) {
      if (newVal) {
        this.creatingSubscription = !!Object.values(newVal).filter((subs) => !subs.subscription).length
      } else {
        this.creatingSubscription = false
      }
      return false
    },
    promoCode () {
      if (this.promoData) {
        this.promoLoading = false
        this.promoData = null
        this.promoError = false
      }
    }
  },
  methods: {
    getCode,
    formatPrice,
    handleCancelSubscription (subsKey) {
      firebase.database().ref(`/users/${this.user.uid}/subscriptions/${subsKey}`).update({ status: 'CANCELLED' })
    },
    async handleRemovePaymentSource (sourceKey) {
      await firebase.database().ref(`/stripe_customers/${this.user.uid}/sources/${sourceKey}`).remove()
    },
    setSubscriptionsWatcher () {
      if (this.sourcesWatcher) this.sourcesWatcher()
      this.sourcesWatcher = firebase.database().ref(`/stripe_customers/${this.user.uid}/sources`).on('value', (sources) => {
        this.stripeSources = sources ? sources.val() : null
        console.log(sources.val())
      })

      if (this.subscriptionsWatcher) this.subscriptionsWatcher()
      this.subscriptionsWatcher = firebase.database().ref(`/users/${this.user.uid}/subscriptions`).on('value', (subs) => {
        this.activeSubscriptions = subs ? subs.val() : null
      })
    },
    async fetchCouponCode () {
      try {
      this.promoError = null
      this.promoLoading = true
       const fetchStripeCoupon = firebase.functions().httpsCallable('fetchStripeCoupon')
        const { data } = await fetchStripeCoupon({ couponCode: this.promoCode })
        this.promoData = data
      } catch (error) {
        this.promoData = null
        this.promoError = error
      } finally {
        this.promoLoading = false
      }
    },
    async fetchSubscriptionPreview () {
      try {
        const fetchSubscriptionPreview = firebase.functions().httpsCallable('fetchSubscriptionPreview')
        const { data } = await fetchSubscriptionPreview({ couponCode: this.promoCode })
        console.log(data)
        this.subscriptionPreview = data
      } catch (error) {
        this.subscriptionPreview = null
        throw error
      }
    },
    async handleSubscribeNow () {
      if (this.creatingSubscription) return false
      try {
        this.promoError = null
        console.log(this.promoCode)
        if (this.promoCode && this.promoCode.trim().length && !this.promoData) {
          return this.fetchCouponCode()
        }
        this.creatingSubscription = true
        await this.$store.dispatch('addStripeSubscription', { couponCode: this.promoCode })
        this.creatingSubscription = false
      } catch (error) {
        console.log(error.message)
      } finally {
        this.creatingSubscription = false
      }
    },
    handleCancelAddNewCard () {
      this.addNewCardModal = false
    },
    async handleAddNewCard (sourceKey = null) {
      if (sourceKey) {
        await this.handleRemovePaymentSource(sourceKey)
      }
      this.addNewCardModal = true
      this.value.error = null
    },
    handlePaymentFormChange ({ complete, error }) {
      this.stripePaymentFormComplete = complete
      this.stripePaymentFormErrors = error
    },
    async createPaymentSource () {
      try {
        this.stripePaymentFormErrors = null
        this.stripePaymentFormBusy = true
        const { token } = await createToken({
          name: this.cardHolderName,
          address_line1: this.addressLine1,
          // address_line2: this.addressLine2,
          address_city:  this.addressCity,
          address_state: this.addressState,
          address_country: this.addressCountry
        })
        await this.$store.dispatch('addStripePaymentSource', { token })
        this.handleCancelAddNewCard()
      } catch (error) {
        this.stripePaymentFormErrors = error
      } finally {
        console.log(this.stripePaymentFormErrors)
        this.stripePaymentFormBusy = false
      }
    },
    onDismissed() {
      // this.$store.dispatch('clearError')
    }
  }
  }
</script>

<style scoped>
.container {
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;

}

.formContainer {
  padding:20px;
  padding-top: 5px;
  padding-bottom: 110px;
}

#buttonRow {
  display:flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

#cardRow {
  margin-top:10px;
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
#submitButton {
  margin-top: 30px;
}
.stripe-card {
  width: 100%;
  padding:10px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 10px;
  margin-top: 10px;

}
.stripe-card.complete {
  border-color: green;
}

.promoInput {
  font-size: 16px;
  width: 100%;
  padding:10px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 10px;
  margin-top: 10px;
  outline: none;
  color: grey;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgb(144, 147, 151);
  font-size: 16px;
}

.promoCodeInput {
  font-size: 16px;
  width:150%;
  padding:10px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 10px;
  margin-top: 10px;
  outline: none;
  color: grey;
}

.coupon-box {
  position: relative;
}

.coupon-box__button {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  right: 10px;
  z-index: 2;
}

@media (min-width: 960px) {
  .md-position-custom {
    position: absolute;
    top: 50%;
    margin-top: 6px!important;
    right: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/User/Subscriptions.vue